const getCurrentSchool = (currentUser, schoolId) => {
  if (currentUser && typeof parseInt(schoolId) === "number") {
    return currentUser.schools.find(school => school.id == schoolId)
  } else {
    return null
  }
}

export default getCurrentSchool
